<section class="fb-login w-full flex justify-center items-center min-h-[90vh] bg-[#fffcf7]">
	<div class="w-full max-w-[756px] min-h-[60vh] bg-white rounded-2xl p-3 md:p-6 m-3 drop-shadow-xl
	flex flex-col md:flex-row justify-between items-stretch">
<!--		<div class="md:flex-[50%] rounded-2xl overflow-hidden relative flex justify-center items-center">-->


<!--			<img ngSrc="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/FKQ1PKIMYJOD4S9PRTU8S10HUPIE00141.jpg"-->
<!--				 width="400"-->
<!--				 height="500"-->
<!--				 class="w-full h-full object-cover"-->
<!--				 alt="Anuprerna">-->
<!--		</div>-->
		<div class="md:flex-[50%] flex justify-center items-center">
			<div class=" p-2 min-w-[80%]">
				<div class="flex items-center gap-2 mb-5">
					<img ngSrc="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo-brown.svg" width="40" height="40" alt="Anuprerna">
					<h1 class="text-2xl uppercase text-[#8E7862]">Anuprerna</h1>
				</div>
				<div *ngIf="!showPasswordForm"
					 class="fb-login-form-container flex flex-col items-stretch">
					<h3 class="font-medium text-2xl mb-2">Forgot Password?</h3>
					<p class="text-[#9fa6b8]">Enter your email registered with us</p>
					<div class="fb-login-form my-3">
						<form [formGroup]="forgotPasswordFormGroup"
							  (ngSubmit)="onEmailSend()">
							<div class="my-2.5">
								<label for="email" class="text-sm font-bold">Email :</label>
								<input class="w-full px-2 py-2 border border-[##F0F5FA] rounded"
									   type="email"
									   id="email"
									   name="username"
									   [formControl]="emailFormControl"
									   placeholder="Enter your email"/>
								<ng-container>
									<p class="text-red-500 text-xs"
									   *ngIf="emailFormControl.invalid && emailFormControl.dirty">
										Email is required.
									</p>
								</ng-container>
							</div>
							<button class="w-full mt-5 rounded bg-[#8E7862] text-white py-2 hover:bg-[#6c5b48] transition-colors"
									type="submit">
								Send
							</button>
						</form>
						<div class="w-full flex justify-end mt-2">
							<a class="text-base text-[#8E7862]"
							   routerLink="/auth">
								< Back to Sign In
							</a>
						</div>
					</div>
				</div>
				<div *ngIf="showPasswordForm"
					 class="fb-login-form-container flex flex-col items-stretch">
					<h3 class="font-medium text-2xl mb-2">Forgot Password?</h3>
					<p class="text-[#9fa6b8]">Reset your password</p>
					<div class="fb-login-form my-3">
						<form [formGroup]="resetPasswordFormGroup"
							  (ngSubmit)="onResetPassword()">
							<div class="my-2.5">
								<label for="password" class="text-sm font-bold">Password :</label>
								<div class="w-full border border-[##F0F5FA] rounded flex items-center justify-between gap-0.5 pr-2">
									<input class="w-full px-2 py-2"
										   [type]="passwordType"
										   id="password"
										   name="password"
										   [formControl]="passwordFormControl"
										   placeholder="Enter your password"/>
									<div (click)="passwordType==='text'? passwordType='password': passwordType='text'"
										 class="cursor-pointer">
										<span *ngIf="passwordType==='password'"
											  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility</span>
										<span *ngIf="passwordType==='text'"
											  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility_off</span>
									</div>
								</div>
								<ng-container>
									<p class="text-red-500 text-xs"
									   *ngIf="passwordFormControl.invalid && passwordFormControl.dirty">
										Password is required. Minimum 8 characters.
									</p>
								</ng-container>
							</div>
							<div class="my-2.5">
								<label for="c-password" class="text-sm font-bold">Confirm Password :</label>
								<div class="w-full border border-[##F0F5FA] rounded flex items-center justify-between gap-0.5 pr-2">
									<input class="w-full px-2 py-2 "
										   [type]="confirmPasswordType"
										   id="c-password"
										   name="confirm-password"
										   [formControl]="confirmPasswordFormControl"
										   placeholder="Re-Enter your password"/>
									<div (click)="confirmPasswordType==='text'? confirmPasswordType='password': confirmPasswordType='text'"
										 class="cursor-pointer">
										<span *ngIf="confirmPasswordType==='password'"
											  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility</span>
										<span *ngIf="confirmPasswordType==='text'"
											  class="material-symbols-outlined text-[#9fa6b8] mt-1">visibility_off</span>
									</div>
								</div>
								<ng-container>
									<p class="text-red-500 text-xs"
									   *ngIf="confirmPasswordFormControl.dirty &&(passwordFormControl.value !== confirmPasswordFormControl.value)">
										Confirm Password does not match with Password
									</p>
								</ng-container>
							</div>

							<button class="w-full mt-5 rounded bg-[#8E7862] text-white py-2 hover:bg-[#6c5b48] transition-colors"
									type="submit">
								Reset Password
							</button>
						</form>
						<div class="w-full flex justify-end mt-2">
							<button class="text-base text-[#8E7862]" (click)="showPasswordForm = false">
								< Back to Enter Email
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
